<template>
  <div>
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 45px;
      "
      class="col form-group"
    >
      <select style="height: 35px; margin-top: 10px" class="w-100 c-select" v-model="objTeam">
        <option style="color: black" value="" disabled hidden>
          {{ getTextInputFavoriteTeam() }}
        </option>
        <option style="color: black" v-for="(team, index) in obj.data" :value="team" :key="index">
          {{ team.entityName }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
/* Services */
import axios from 'axios'

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FavoriteTeam',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    objTeam: '',
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject']),
  },
  mounted() {
    this.getTeamsByOwner()
    this.getTextInputFavoriteTeam()
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: 'Atenção',
        variant: variant,
        solid: true,
      })
    },
    getTextInputFavoriteTeam() {
      if (this.config.ownerId == 169) return 'Escolha a sua federação'
      else return 'Escolha seu time do coração'
    },
    getTeamsByOwner() {
      const url = `${process.env.VUE_APP_FANBASESECURITY}/${process.env.VUE_APP_BASEENV}/Events/getSubListByOwnerId/${this.config.ownerId}`
      axios.get(url).then(
        response => {
          this.obj = response.data
        },
        error => {
          alert(error)
        },
      )
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      let objTeam = {}

      objTeam.team = this.objTeam.id

      if (!this.objTeam) {
        hasErrors = true
        const warningMsg = 'É necessário escolher uma opção'
        this.addRegistrationError({ msg: warningMsg })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', objTeam)

        this.$emit('next')
      }
    },
  },
}
</script>
